<!--
 * @Author: qhy
 * @Date: 2021-11-09 09:20:41
 * @LastEditTime: 2022-08-20 15:37:29
 * @LastEditors: qhy
 * @Description:
 * @FilePath: \jl1store_front\src\App.vue
-->
<template>
  <v-app style="font-family: '微软雅黑'" v-resize="onResize">
    <v-content v-if="$vuetify.breakpoint.name != 'xs' ||
      $route.path == '/Register_mobile' ||
      $route.path == '/MobilePublicity' ||
      $route.path == '/PrivacyPolicy_mobile' ||
      $route.path == '/ServiceAgreement_mobile'
      ">
      <home-navi :key="$route.path" v-if="!(hideTopNaviUrls.indexOf($route.path) > -1) &&
        !/\/Archive/.test($route.path) && $route.path != '/homeWork' && $route.path != '/coursePlay'
        " style="z-index: 999" />

      <router-view v-if="isRouterAlive" />
      <!-- <div style="width: 100%;height: 2000px"></div> -->
      <!-- <home-footer v-if="$route.path !== '/DataSetInfo'" /> -->
      <home-footer v-if="
        $route.path == '/' ||
        $route.path == '/courseDetail' ||
        $route.path == '/directSeeding'
        " />
        <HomeFooterWhite  v-if="
        $route.path == '/signInContent' ||
        $route.path == '/signInResult' ||
        $route.path == '/globalCourse' ||
        $route.path == '/universityUserCenter' ||
        $route.path == '/courseShow' ||
        $route.path == '/homeWork' ||
        $route.path == '/coursePlay' ||
        $route.path == '/graduationCertificate' ||
        $route.path == '/excellentRecognition'
        "></HomeFooterWhite>
    </v-content>
    <NoMobile v-if="$vuetify.breakpoint.name == 'xs' &&
      $route.path != '/Register_mobile' &&
      $route.path != '/PrivacyPolicy_mobile' &&
      $route.path != '/ServiceAgreement_mobile' &&
      $route.path != '/MobilePublicity'
      " /> 
  </v-app>
</template>

<script>
import HomeNavi from "./components/HomeNavi";
import HomeFooter from "./components/HomeFooter";
import HomeFooterWhite from "./components/HomeFooterWhite";
import NoMobile from "./views/access/NoMobile";
import DevicePixelRatio from "./devicePixelRatio";
export default {
  name: "App",
  components: {
    HomeFooter,
    HomeNavi,
    HomeFooterWhite,
    NoMobile,
  },
  provide() {
    return {
      reload: this.reload,
    };
  },
  data: () => ({
    isRouterAlive: true,
    isMobile:false,
    hideTopNaviUrls: [
      "/UserEditPassword",
      "/UserBoundPhone",
      "/UserCenter",
      "/MyOrderAppraise",
      "/MyOrderManage",
      "/MyOrderDetail_program",
      "/MyOrderDetail",
      "/MyApplication",
      "/ApplicationCenter",
      "/DataSetInfo",
      "/Login",
      "/UserAddressManage",
      "/UserInvoiceManage",
      "/Register",
      "/Register_mobile",
      "/PrivacyPolicy_mobile",
      "/ServiceAgreement_mobile",
      "/MobilePublicity",
      "/404",
    ],
  }),
  computed: {
    lang() {
      return this.$vuetify.lang.current;
    },
  },

  watch: {
    lang(val) {
      localStorage.setItem("lang", val);
    },
  },
  created() {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    this.isMobile=isMobile
    // var currentPath = window.location.href
    // if(currentPath.includes("http://")){
    //   currentPath=currentPath.replace("http://","")
    // }
    // var url = "jl1mall://"+currentPath;
    // if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
    //   var loadDateTime = new Date();
    //   window.setTimeout(function () {
    //     var timeOutDateTime = new Date();
    //     if (timeOutDateTime - loadDateTime < 5000) {
    //       window.location = url;
    //     } else {
    //       window.close();
    //     }
    //   },25);
    //   window.location = "https://www.jl1mall.com/loginapi/app/version/queryIosLatestAppVersionDownloadUrl";
    //   // window.setTimeout(function () {
    //   //   window.location = "https://www.jl1mall.com/loginapi/app/version/queryIosLatestAppVersionDownloadUrl";
    //   // }, 3000);
    // } else if (navigator.userAgent.match(/android/i)) {
    //   window.location.href = url;
    //   window.setTimeout(function () {
    //     window.location.href = "https://www.jl1mall.com/loginapi/app/version/queryAndroidLatestAppVersionDownloadUrl";
    //   }, 3000);
    // }



    // new DevicePixelRatio().init()
    window.addEventListener("scroll", this.onScroll);
    window.addEventListener("resize", this.onResize);
    this.$store.state.innerHeight = window.innerHeight;

    // 关闭当前浏览器窗口或者切换路由都会调用
    // window.onbeforeunload = () => {
    //   localStorage.setItem("userId", "");
    // };
  },
  mounted() {
    if (localStorage.getItem("lang")) {
      this.$vuetify.lang.current = localStorage.getItem("lang");
    } else {
      if (
        (navigator.browserLanguage || navigator.language).toLowerCase() ===
        "zh-cn"
      ) {
        this.$vuetify.lang.current = "zhHans";
      } else {
        this.$vuetify.lang.current = "en";
      }
    }
    //识别屏幕缩放比例
    // console.log("识别屏幕缩放比例");
    // console.log(this.detectZoom());
    this.$store.state.screenZoom = this.detectZoom();
  },
  methods: {
    detectZoom() {
      var ratio = 0,
        screen = window.screen,
        ua = navigator.userAgent.toLowerCase();

      if (window.devicePixelRatio !== undefined) {
        ratio = window.devicePixelRatio;
      } else if (~ua.indexOf("msie")) {
        if (screen.deviceXDPI && screen.logicalXDPI) {
          ratio = screen.deviceXDPI / screen.logicalXDPI;
        }
      } else if (
        window.outerWidth !== undefined &&
        window.innerWidth !== undefined
      ) {
        ratio = window.outerWidth / window.innerWidth;
      }
      if (ratio) {
        ratio = Math.round(ratio * 100);
      }
      return ratio;
    },
    onScroll() {
      this.$store.state.pageYOffset = window.pageYOffset;
    },
    onResize() {
      this.$store.state.innerHeight = window.innerHeight;
      this.$store.state.windowSize = {
        x: window.innerWidth,
        y: window.innerHeight,
      }; //access用到了
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
  },
};
</script>

<style lang="scss">
@import "./global.scss";
</style>
